/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfListOfGroupPriceDetailDto } from '../models/custom-result-of-list-of-group-price-detail-dto';
import { CustomResultOfPaginatedListOfGroupPriceDetailWithPaginationDto } from '../models/custom-result-of-paginated-list-of-group-price-detail-with-pagination-dto';
import { groupPriceDetailsCreateGet } from '../fn/group-price-details/group-price-details-create-get';
import { GroupPriceDetailsCreateGet$Params } from '../fn/group-price-details/group-price-details-create-get';
import { groupPriceDetailsCreatePost } from '../fn/group-price-details/group-price-details-create-post';
import { GroupPriceDetailsCreatePost$Params } from '../fn/group-price-details/group-price-details-create-post';
import { groupPriceDetailsDelete } from '../fn/group-price-details/group-price-details-delete';
import { GroupPriceDetailsDelete$Params } from '../fn/group-price-details/group-price-details-delete';
import { groupPriceDetailsGetGroupPriceDetailById } from '../fn/group-price-details/group-price-details-get-group-price-detail-by-id';
import { GroupPriceDetailsGetGroupPriceDetailById$Params } from '../fn/group-price-details/group-price-details-get-group-price-detail-by-id';
import { groupPriceDetailsGetGroupPriceDetailByOrganizationId } from '../fn/group-price-details/group-price-details-get-group-price-detail-by-organization-id';
import { GroupPriceDetailsGetGroupPriceDetailByOrganizationId$Params } from '../fn/group-price-details/group-price-details-get-group-price-detail-by-organization-id';
import { groupPriceDetailsGetGroupPriceDetailsAudit } from '../fn/group-price-details/group-price-details-get-group-price-details-audit';
import { GroupPriceDetailsGetGroupPriceDetailsAudit$Params } from '../fn/group-price-details/group-price-details-get-group-price-details-audit';
import { groupPriceDetailsGetGroupPriceDetailsWithPagination } from '../fn/group-price-details/group-price-details-get-group-price-details-with-pagination';
import { GroupPriceDetailsGetGroupPriceDetailsWithPagination$Params } from '../fn/group-price-details/group-price-details-get-group-price-details-with-pagination';
import { groupPriceDetailsUpdateGet } from '../fn/group-price-details/group-price-details-update-get';
import { GroupPriceDetailsUpdateGet$Params } from '../fn/group-price-details/group-price-details-update-get';
import { groupPriceDetailsUpdatePut } from '../fn/group-price-details/group-price-details-update-put';
import { GroupPriceDetailsUpdatePut$Params } from '../fn/group-price-details/group-price-details-update-put';

@Injectable({ providedIn: 'root' })
export class GroupPriceDetailsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `groupPriceDetailsGetGroupPriceDetailsWithPagination()` */
  static readonly GroupPriceDetailsGetGroupPriceDetailsWithPaginationPath = '/GroupPriceDetails/GetGroupPriceDetailsWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceDetailsGetGroupPriceDetailsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceDetailsGetGroupPriceDetailsWithPagination$Response(params: GroupPriceDetailsGetGroupPriceDetailsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGroupPriceDetailWithPaginationDto>> {
    return groupPriceDetailsGetGroupPriceDetailsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceDetailsGetGroupPriceDetailsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceDetailsGetGroupPriceDetailsWithPagination(params: GroupPriceDetailsGetGroupPriceDetailsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGroupPriceDetailWithPaginationDto> {
    return this.groupPriceDetailsGetGroupPriceDetailsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGroupPriceDetailWithPaginationDto>): CustomResultOfPaginatedListOfGroupPriceDetailWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `groupPriceDetailsGetGroupPriceDetailById()` */
  static readonly GroupPriceDetailsGetGroupPriceDetailByIdPath = '/GroupPriceDetails/GetGroupPriceDetailById';

  /**
   * Get GroupPriceDetail By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceDetailsGetGroupPriceDetailById()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceDetailsGetGroupPriceDetailById$Response(params?: GroupPriceDetailsGetGroupPriceDetailById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGroupPriceDetailDto>> {
    return groupPriceDetailsGetGroupPriceDetailById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get GroupPriceDetail By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceDetailsGetGroupPriceDetailById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceDetailsGetGroupPriceDetailById(params?: GroupPriceDetailsGetGroupPriceDetailById$Params, context?: HttpContext): Observable<CustomResultOfListOfGroupPriceDetailDto> {
    return this.groupPriceDetailsGetGroupPriceDetailById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGroupPriceDetailDto>): CustomResultOfListOfGroupPriceDetailDto => r.body)
    );
  }

  /** Path part for operation `groupPriceDetailsCreateGet()` */
  static readonly GroupPriceDetailsCreateGetPath = '/GroupPriceDetails/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceDetailsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceDetailsCreateGet$Response(params?: GroupPriceDetailsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return groupPriceDetailsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceDetailsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceDetailsCreateGet(params?: GroupPriceDetailsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.groupPriceDetailsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `groupPriceDetailsCreatePost()` */
  static readonly GroupPriceDetailsCreatePostPath = '/GroupPriceDetails/Create';

  /**
   * Create GroupPriceDetail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceDetailsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceDetailsCreatePost$Response(params: GroupPriceDetailsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return groupPriceDetailsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create GroupPriceDetail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceDetailsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceDetailsCreatePost(params: GroupPriceDetailsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.groupPriceDetailsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `groupPriceDetailsUpdateGet()` */
  static readonly GroupPriceDetailsUpdateGetPath = '/GroupPriceDetails/Update';

  /**
   * Get GroupPriceDetail By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceDetailsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceDetailsUpdateGet$Response(params?: GroupPriceDetailsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGroupPriceDetailDto>> {
    return groupPriceDetailsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get GroupPriceDetail By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceDetailsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceDetailsUpdateGet(params?: GroupPriceDetailsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfListOfGroupPriceDetailDto> {
    return this.groupPriceDetailsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGroupPriceDetailDto>): CustomResultOfListOfGroupPriceDetailDto => r.body)
    );
  }

  /** Path part for operation `groupPriceDetailsUpdatePut()` */
  static readonly GroupPriceDetailsUpdatePutPath = '/GroupPriceDetails/Update';

  /**
   * Update GroupPriceDetail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceDetailsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceDetailsUpdatePut$Response(params: GroupPriceDetailsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return groupPriceDetailsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update GroupPriceDetail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceDetailsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceDetailsUpdatePut(params: GroupPriceDetailsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.groupPriceDetailsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `groupPriceDetailsDelete()` */
  static readonly GroupPriceDetailsDeletePath = '/GroupPriceDetails/{id}';

  /**
   * Delete GroupPriceDetail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceDetailsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceDetailsDelete$Response(params: GroupPriceDetailsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return groupPriceDetailsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete GroupPriceDetail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceDetailsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceDetailsDelete(params: GroupPriceDetailsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.groupPriceDetailsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `groupPriceDetailsGetGroupPriceDetailsAudit()` */
  static readonly GroupPriceDetailsGetGroupPriceDetailsAuditPath = '/GroupPriceDetails/GetGroupPriceDetailsAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceDetailsGetGroupPriceDetailsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceDetailsGetGroupPriceDetailsAudit$Response(params: GroupPriceDetailsGetGroupPriceDetailsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return groupPriceDetailsGetGroupPriceDetailsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceDetailsGetGroupPriceDetailsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceDetailsGetGroupPriceDetailsAudit(params: GroupPriceDetailsGetGroupPriceDetailsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.groupPriceDetailsGetGroupPriceDetailsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `groupPriceDetailsGetGroupPriceDetailByOrganizationId()` */
  static readonly GroupPriceDetailsGetGroupPriceDetailByOrganizationIdPath = '/GroupPriceDetails/GetGroupPriceDetailByOrganizationId';

  /**
   * دریافت تعرفه بر اساس شناسه سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceDetailsGetGroupPriceDetailByOrganizationId()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceDetailsGetGroupPriceDetailByOrganizationId$Response(params?: GroupPriceDetailsGetGroupPriceDetailByOrganizationId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGroupPriceDetailDto>> {
    return groupPriceDetailsGetGroupPriceDetailByOrganizationId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعرفه بر اساس شناسه سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceDetailsGetGroupPriceDetailByOrganizationId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceDetailsGetGroupPriceDetailByOrganizationId(params?: GroupPriceDetailsGetGroupPriceDetailByOrganizationId$Params, context?: HttpContext): Observable<CustomResultOfListOfGroupPriceDetailDto> {
    return this.groupPriceDetailsGetGroupPriceDetailByOrganizationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGroupPriceDetailDto>): CustomResultOfListOfGroupPriceDetailDto => r.body)
    );
  }

}
